import messages from '../../../locale/jsonMessages';

const validate = values => {

  const errors = {}

  if (values.paymentMethodId == 1 && !values.paymentCurrency) {
    errors.paymentCurrency = messages.pleaseChooseCurrency;
  }

  return errors
}

export default validate;